export default class HistoricalPlacesMapStaticSettings {

    public window = {
        visible: false,
        options: {
            pixelOffset: null
        },
        coordinates: {
            latitude: 0,
            longitude: 0
        },
        markers: []
    }

    public center = {
        latitude: 50.087743,
        longitude: 14.478982
    }

    public zoom = 8;

    public bounds = {};

    public options = {
        scrollwheel: true
    };

    public markers = [];
}